import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  translationString: string;
  delta: number;
}

const DeltaBubble = ({ translationString, delta }: Props) => {
  const { t } = useTranslation('wap');

  const sign = delta >= 0 ? '+' : '-';

  return (
    <div
      className={classNames('deltabubble', {
        'deltabubble--positive': delta > 0,
        'deltabubble--negative': delta < 0,
      })}
    >
      <div className="deltabubble__tail" />
      <div className="deltabubble__background">
        <b>{sign}</b>
        {t(translationString, {
          count: Math.abs(delta),
        })}
      </div>
    </div>
  );
};

export default DeltaBubble;
